//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'drawer',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'left'
    },
    showMode: {
      type: String,
      default: 'overlay'
    },
    drawerStyle: Object
  },
  data () {
    return {
      drawerWidth: 0,
      translateX: 0
    }
  },
  watch: {
    show: function () {
      if (!this.show) {
        this.$emit('on-hide')
      } else {
        this.$emit('on-show')
      }
      if (this.showMode === 'overlay') {
        return
      }
      if (!this.show) {
        this.translateX = 0
      } else {
        this.translateX = this.placement === 'left' ? this.drawerWidth : -this.drawerWidth
      }
    }
  },
  methods: {
    hideMask () {
      this.$emit('update:show', false)
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.drawerWidth = this.$refs.drawer.clientWidth
    })
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/drawer/index.vue